var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_17436_44153",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H46C48.2091 0 50 1.79086 50 4V46C50 48.2091 48.2091 50 46 50H4C1.79086 50 0 48.2091 0 46V4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H46C48.2091 0 50 1.79086 50 4V46C50 48.2091 48.2091 50 46 50H4C1.79086 50 0 48.2091 0 46V4Z",
    fill: "#71758F",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50H0ZM50 50H0H50ZM4 50C1.23858 50 -1 47.7614 -1 45V5C-1 2.23858 1.23858 0 4 0C2.34315 0 1 1.79086 1 4V46C1 48.2091 2.34315 50 4 50ZM50 0V50V0Z",
    fill: "#0C0F25",
    mask: "url(#path-1-inside-1_17436_44153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 34L29.514 29.506L34 34ZM32 23.5C32 25.7543 31.1045 27.9163 29.5104 29.5104C27.9163 31.1045 25.7543 32 23.5 32C21.2457 32 19.0837 31.1045 17.4896 29.5104C15.8955 27.9163 15 25.7543 15 23.5C15 21.2457 15.8955 19.0837 17.4896 17.4896C19.0837 15.8955 21.2457 15 23.5 15C25.7543 15 27.9163 15.8955 29.5104 17.4896C31.1045 19.0837 32 21.2457 32 23.5V23.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.51cdc1f5c0f34e1aa266d5e149a2cf17.svg";
export { ForwardRef as ReactComponent };